import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  field: {
    margin: [theme.spacing(3), 0],
    width: '100%',
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/TextFieldQuestion/useStyles.js